import type { EBaseSetupGuideCampaign } from '~/modules/campaign/types';

export enum ESetupGuideCampaignPrice {
  // Picking the Control is the only product action: the duplicate + price write both happen on save
  // rather than as separate merchant steps.
  CHOOSE_TESTED_PRODUCT = 'CHOOSE_TESTED_PRODUCT',
  EDIT_VARIANT_PRICE = 'EDIT_VARIANT_PRICE',
}

export type ISetupGuideCampaignPrice = ESetupGuideCampaignPrice | EBaseSetupGuideCampaign;

/** Shop meta starts out as `{}` and only ever gains the steps the shop has completed. */
export type IGSetupGuidePriceStatuses = Partial<Record<ISetupGuideCampaignPrice, boolean>>;
